import { loadData, UserDataProvider } from "../../Core/UserDataProvider"
import { controllers } from "../Controllers"


class CompensationController {

    // ── Salary configs (admin only) ──

    getSalaryConfigs = async (params: any = {}) => {
        const { userToken } = controllers().auth
        if (!userToken) return
        const response = loadData(UserDataProvider.getSalaryConfigs, { userToken, ...params })
        return response
    }

    setSalaryConfig = async (payload: {
        user_id: number;
        salary_day: number;
        basic_salary_amount: string;
        date_of_employment: string;
        date_of_lay_off: string | null;
    }) => {
        const { userToken } = controllers().auth
        if (!userToken) return
        const response = loadData(UserDataProvider.setSalaryConfig, { userToken, ...payload })
        return response
    }

    // ── Issuing (admin only) ──

    getCompensationPreview = async (payload: {
        worker_id: number;
        period_start: string;
        period_end: string;
        compensation_date?: string;
        notes?: string;
        bonuses?: any[];
    }) => {
        const { userToken } = controllers().auth
        if (!userToken) return
        const response = loadData(UserDataProvider.getCompensationPreview, { userToken, ...payload })
        return response
    }

    issueCompensation = async (payload: {
        worker_id: number;
        period_start: string;
        period_end: string;
        compensation_date?: string;
        notes?: string;
        bonuses: any[];
    }) => {
        const { userToken } = controllers().auth
        if (!userToken) return
        const response = loadData(UserDataProvider.issueCompensation, { userToken, ...payload })
        return response
    }

    // ── Viewing (admin: all; worker: own — enforced server-side) ──

    listCompensations = async (params: { worker_id?: number; page?: number; per_page?: number } = {}) => {
        const { userToken } = controllers().auth
        if (!userToken) return
        const response = loadData(UserDataProvider.listCompensations, { userToken, ...params })
        return response
    }

    getCompensationDetail = async (compensationId: number) => {
        const { userToken } = controllers().auth
        if (!userToken) return
        const response = loadData(UserDataProvider.getCompensationDetail, { userToken, compensationId })
        return response
    }

    // ── Invoice templates (admin only) ──

    getInvoiceTemplates = async () => {
        const { userToken } = controllers().auth
        if (!userToken) return
        const response = loadData(UserDataProvider.getInvoiceTemplates, { userToken })
        return response
    }

    saveInvoiceTemplate = async (payload: { user_id?: number | null; name?: string; html: string }) => {
        const { userToken } = controllers().auth
        if (!userToken) return
        const response = loadData(UserDataProvider.saveInvoiceTemplate, { userToken, ...payload })
        return response
    }

    // ── Invoice download links ──
    // download_compensation_invoice is a plain file-serving GET endpoint,
    // not a fetchData/loadData JSON call — it's used directly as an <a href>.
    // The backend's `invoice_url` on a compensation is built with reverse()
    // and has no token on it (same as EmailAttachment.url), so a plain <a>/
    // <iframe> tag needs it appended by hand — headers aren't an option there.
    // Fetch-based "download" buttons can skip this and send the
    // Authorization header instead.
    getInvoiceDownloadUrl = (invoiceUrl: string | null | undefined, download: boolean = false) => {
        const { userToken } = controllers().auth
        if (!invoiceUrl) return ''
        const separator = invoiceUrl.includes('?') ? '&' : '?'
        return `${invoiceUrl}${separator}token=${userToken}${download ? '&download=true' : ''}`
    }
}

export { CompensationController }